import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["arrivalHiddenField"];

  updateArrivalHiddenField(event) {
    this.arrivalHiddenFieldTarget.value = event.target.value;
  }
}
